// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

export function MessagePixPayment(): Node {
  return <PixPaymentMessage />;
}

function PixPaymentMessage(): Node {
  return (
    <Root>
      <ChildrenWrapper>
        <Title>Pague com PIX</Title>
        <p>O PIX Open Finance é <strong>rápido, fácil e seguro!</strong></p>
        <p>Você será redirecionado para o banco ou carteira digital de sua preferência:</p>
      </ChildrenWrapper>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-content: center;
`;

const ChildrenWrapper = styled.div`
  min-width: 80%;
  margin: auto;
  padding-inline: 40px;
  font-family: ${theme.fontFamily.sansSerif};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #555555;
`;

const Title = styled.h1`
  font-family: ${theme.fontFamily.display};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
  color: #000000;
  padding-bottom: 5px;
`;
